/* eslint-disable */
import API from '../../helpers/API';
import CryptoJS from 'crypto-js';
import {
  GET_GENDER_DROPDOWN_LIST, GET_ID_TYPE_DROPDOWN_LIST,
  SET_CAPTCHA_IMAGE, SET_GET_EMAIL_OTP_RESPONSE, SET_GET_MOBILE_OTP_RESPONSE, SHOW_LOADER, HIDE_LOADER, SET_VERIFY_OTP_FLAG_LOGIN, SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD, SET_GET_USERNAME_OTP_RESPONSE,
  SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL, SET_VERIFY_OTP_FLAG_FORGOT_EMAIL, SET_VERIFY_OTP_FLAG_FORGOT_MOBILE, SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE, SET_GUIDELINE_LINKS, SET_MODULE_ENABLE_DISABLE,
  SET_API_CALL_FOR_MODULE, GET_OTP_DATA_EMAIL, GET_OTP_DATA_MOBILE, GET_OTP_DATA_USERNAME, SET_IS_MOBILE_NO_ALREADY_EXIST_FLG, SET_IS_EMAIL_ID_ALREADY_EXIST_FLG,
  GET_LOGIN_STATUS, SET_ADMIN_DEPARTMENTS, DASHBOARD_COUNT, SET_ADMIN_OTP_VERIFIED_FLAG,
  SET_SECURITY_ANSWERS_FOR_LOGIN, SET_PROFILE_CREATION_LOOKUP, SET_GET_EMAIL_OTP_FLAG, SET_GET_MOBILE_OTP_FLAG,
  SET_USER_SESSION, SET_DIGILOCKER_ACCESSTOKEN_DATA, SET_BOARDS_LIST, SET_HELPLINE_DETAILS, GRIEVANCE_DETAILS, GRIEVANCE_LIST, GET_GRIEVANCE_TYPE_DROPDOWN_LIST, SET_VERIFY_OTP_FLAG_GRIEVANCE_MOBILE, SET_GRIEVANCE_TABLE_LIST, SET_CONFIGURATION_DIGILOCKER_FLAG,
  GET_ADVERTISEMENT_TYPE_DROPDOWN_LIST,
  GET_SUB_TYPE_GRIEVANCE_DROPDOWN_LIST,
  SET_LOCK_UNLOCK_PROFILE_FLG,
  GET_WEB_APP_VERSION, SET_YEAR, SET_ADVT_DETAILS, SET_GET_PAST_ADVERTISEMENT, SET_GET_ACTIVE_ADVERTISEMENT, SET_APPLICATION_STAGES_VIEW,
  GET_SLIDE_SHOW_ACTIVE_ADVT,
  EDIT_SET_LOCK_UNLOCK_PROFILE,
  SET_OTR_DETAILS
} from '../../common/constants/ActionTypes';
import { OTPS, VERIFYOTP, LOOKUP_OPTION, MODULE_CHECK, EASEBUZZ_CALLBACK, FORCEFULLY_LOGOUT, LOGIN, GET_VERIFY_CAPTCHA, VERIFY_SECURITY_ANSWER, GET_DIGILOCKER_URL, GET_DIGILOCKER_ACCESSTOKEN, GET_DIGILOCKER_ACCESSTOKEN_LOGIN, GRIEVANCE_SAVE, GET_GRIEVANCE_LIST, GET_GRIEVANCE_DETAILS, UPDATE_GRIEVANCE_DATA, CONFIGURATION, GET_ADVERTISEMENT_DROPDOWN, VERIFY_QUALIFICATION_DIGILOCKER, GET_DEPARTMENTS, GET_ADMIN_OTP, ADMIN_LOGIN, GET_DASHBOARD_COUNT, APPLICATION_VERSION_API, GET_YEAR_LIST, GETADVERTISEMENT, GETPASTADVERTISEMENT, GET_SLIDE_SHOW_ACTIVE_ADVT_API, ADMIN_UPDATE_PROFILE, GET_OTR_DETAILS } from '../../common/constants/endpoints';
import { toastr } from 'react-redux-toastr';
import FileDownload from "js-file-download";
import commonLabels from "../../my_account/labels/common_en.json";
import { ENCR_DECR_KEY } from "../../configuration";
import commonEnLabels from "../../common/labels/common_en.json";
import { getPersonalInfoDigilockerStatus } from '../../candidate_profile_creation/actions/profileAction';
import { getAdvertisements } from './../../application_management/actions/advertisementAction';
import axios from 'axios';
import { dispatchEvent } from '@testing-library/user-event/dist/cjs/event/dispatchEvent.js';


const decryptKey = CryptoJS.enc.Utf8.parse(ENCR_DECR_KEY);
const decryptIV = CryptoJS.enc.Utf8.parse(ENCR_DECR_KEY);
export function encryptData(data) {
  try {
    const encrypted = CryptoJS.AES.encrypt(data, decryptKey, {
      iv: decryptIV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  } catch (error) {
    console.error(commonEnLabels.COMMON.ENCRYPTION_FAILED, error);
    return null;
  }
}

export function decryptData(encryptedData) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, decryptKey, {
      iv: decryptIV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error(commonEnLabels.COMMON.DECRYPTION_FAILED, error);
    return null;
  }
}

/* BPSC API INTREGRATION*/

export const generateOTP = (otpDetails) => {

  return async (dispatch) => {
    dispatch({
      payload: false,
      type: SET_IS_MOBILE_NO_ALREADY_EXIST_FLG,
    });
    dispatch({
      payload: false,
      type: SET_IS_EMAIL_ID_ALREADY_EXIST_FLG,
    });
    dispatch(showLoader());
    try {
      let request;
      switch (otpDetails.type) {
        case "email":
          if (otpDetails.email === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_EMAIL_ID);
            return;
          }
          request = {
            email: otpDetails.email,
            mobile: "",
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;
        case "mobile":
          if (otpDetails.mobile === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_MOBILE_NUMBER);
            return;
          }
          request = {
            email: "",
            mobile: otpDetails.mobile,
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;
        default:
          dispatch(hideLoader());
          toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
          return;
      }
      let response = await API.post(OTPS, request);
      let emailOTPResponse;
      let mobileOTPResponse;
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        switch (response.data.type) {
          case "EMAIL":
            emailOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };
            dispatch({
              payload: emailOTPResponse,
              type: SET_GET_EMAIL_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_EMAIL,
            });
            if (otpDetails.isForgotPassword) {
              mobileOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: mobileOTPResponse,
                type: SET_GET_MOBILE_OTP_RESPONSE,
              });
            }
            if (otpDetails.getOtpOnlyFor === "EMAIL") {
              toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_EMAIL);
            } else {
              toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_EMAIL);
            }
            break;
          case "MOBILE":
            mobileOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };
            dispatch({
              payload: mobileOTPResponse,
              type: SET_GET_MOBILE_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_MOBILE,
            });
            if (otpDetails.isForgotPassword) {
              emailOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: emailOTPResponse,
                type: SET_GET_EMAIL_OTP_RESPONSE,
              });
            }
            toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_MOBILE);
            break;
          default:
            toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
            return;
        }
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      if (
        errorMessage === commonLabels.ENTERED_MOBILE_NO_IS_ALREADY_EXIST &&
        otpDetails.type === "mobile"
      ) {
        dispatch({
          payload: true,
          type: SET_IS_MOBILE_NO_ALREADY_EXIST_FLG,
        });
      } else if (
        errorMessage === commonLabels.ENTERED_EMAIL_ID_IS_ALREADY_EXIST &&
        otpDetails.type === "email"
      ) {
        dispatch({
          payload: true,
          type: SET_IS_EMAIL_ID_ALREADY_EXIST_FLG,
        });
      }
      toastr.error(commonLabels.GET_OTP_ERROR, errorMessage);
    }
  };
};

export const verificationOfOTP = (reqBody, screen) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {

      let response = await API.post(VERIFYOTP, reqBody);
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response.data) {
        toastr.success(commonEnLabels.COMMON.OTP_VERIFICATION_SUCCESSFUL);
      } else {
        toastr.error(commonEnLabels.COMMON.OTP_VERIFICATION_UNSUCCESSFUL);
      }
      if (screen === "login") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
      }
      if (screen === "forgotPassword") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
      if (screen === "registration-email") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
        });
      }
      if (screen === "registration-mobileNumber") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
        });
      }
      if (screen === "grievance-mobileNumber") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_GRIEVANCE_MOBILE,
        });
      }
      if (screen === "home-email") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_FORGOT_EMAIL,
        });
      }
      if (screen === "home-mobileNumber") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_FORGOT_MOBILE,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};

export const getGenderDropdownValues = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    let response = await API.get(LOOKUP_OPTION, {
      params: {
        module: "profile_creation",
        type: "gender",
      },
    });
    if (response != null) {
      dispatch(hideLoader());
    }
    dispatch({
      payload: response && response.data ? response.data : [],
      type: GET_GENDER_DROPDOWN_LIST,
    });
  };
};

export const getIdTypeDropdownValues = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    let response = await API.get(LOOKUP_OPTION, {
      params: {
        module: "profile_creation",
        type: "id_type",
      },
    });
    if (response != null) {
      dispatch(hideLoader());
    }
    dispatch({
      payload: response && response.data ? response.data : [],
      type: GET_ID_TYPE_DROPDOWN_LIST,
    });
  };
};

export const getAllLookupOptionsAPI = () => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let response = await API.get(LOOKUP_OPTION, {
        params: { module: "profile_creation" },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data ? response.data : [],
        type: SET_PROFILE_CREATION_LOOKUP,
      });

    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};
/*-------------------------------------------------------------------------------------------------------------- */

export const generateCaptcha = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.post(OTPS, {
        type: "captcha",
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        let captchaId = response.data.id;
        dispatch({
          payload: captchaId,
          type: SET_CAPTCHA_IMAGE,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_GENERATING_CAPTCHA_IMAGE, errorMessage);
        return;
      }
    }
  };
};

export const generateOTPForgotPassword = (otpDetails) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let request;
      switch (otpDetails.type) {
        case "email":
          if (otpDetails.email === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_EMAIL_ID);
            return;
          }
          request = {
            email: otpDetails.email,
            mobile: "",
            username: "",
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;
        case "mobile":
          if (otpDetails.mobile === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_MOBILE_NUMBER);
            return;
          }
          request = {
            email: "",
            mobile: otpDetails.mobile,
            username: "",
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;
        case "username":
          if (otpDetails.username === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_USERNAME);
            return;
          }
          request = {
            email: "",
            mobile: "",
            username: otpDetails.username,
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;
        default:
          dispatch(hideLoader());
          toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
          return;
      }
      let response = await API.post(OTPS, request);
      let emailOTPResponse;
      let mobileOTPResponse;
      let userNameOTPResponse;
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        switch (response.data.type) {
          case "EMAIL":
            emailOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };
            dispatch({
              payload: emailOTPResponse,
              type: SET_GET_EMAIL_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_EMAIL,
            });
            if (otpDetails.isForgotPassword) {
              mobileOTPResponse = {
                id: "",
                type: "",
              };
              userNameOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: mobileOTPResponse,
                type: SET_GET_MOBILE_OTP_RESPONSE,
              });
              dispatch({
                payload: userNameOTPResponse,
                type: SET_GET_USERNAME_OTP_RESPONSE,
              });
            }
            toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_EMAIL);
            break;
          case "MOBILE":
            mobileOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };

            dispatch({
              payload: mobileOTPResponse,
              type: SET_GET_MOBILE_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_MOBILE,
            });
            if (otpDetails.isForgotPassword) {
              emailOTPResponse = {
                id: "",
                type: "",
              };
              userNameOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: emailOTPResponse,
                type: SET_GET_EMAIL_OTP_RESPONSE,
              });
              dispatch({
                payload: userNameOTPResponse,
                type: SET_GET_USERNAME_OTP_RESPONSE,
              });
            }
            toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_MOBILE);
            break;
          case "username":
            userNameOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };
            dispatch({
              payload: userNameOTPResponse,
              type: SET_GET_USERNAME_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_USERNAME,
            });
            if (otpDetails.isForgotPassword) {
              emailOTPResponse = {
                id: "",
                type: "",
              };
              mobileOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: emailOTPResponse,
                type: SET_GET_EMAIL_OTP_RESPONSE,
              });
              dispatch({
                payload: mobileOTPResponse,
                type: SET_GET_MOBILE_OTP_RESPONSE,
              });
            }
            toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_MOBILE);
            break;
          default:
            toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
            return;
        }
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      if (
        errorMessage ===
        commonEnLabels.VALIDATE_MESSAGE.NOT_A_REGISTERED_MOBILE_NO
      ) {
        dispatch({
          payload: true,
          type: SET_GET_MOBILE_OTP_FLAG,
        });
      } else if (
        errorMessage ===
        commonEnLabels.VALIDATE_MESSAGE.NOT_A_REGISTERED_EMAIL_ID
      ) {
        dispatch({
          payload: true,
          type: SET_GET_EMAIL_OTP_FLAG,
        });
      }
      toastr.error(commonLabels.GET_OTP_ERROR, errorMessage);
    }
  };
};

export const enableOTPButton = (screen) => {
  return (dispatch) => {
    if (screen === "login") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_LOGIN,
      });
    }
    if (screen === "forgotPassword") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
      });
    }
    if (screen === "registration-email") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
      });
    }
    if (screen === "registration-mobileNumber") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
      });
    }
    if (screen === "home-email") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_FORGOT_EMAIL,
      });
    }
    if (screen === "home-mobileNumber") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_FORGOT_MOBILE,
      });
    }
  };
};

export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const checkHas2018RecoLetter = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get("/oas/api/v1/has2018recoletter", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage);
      return;
    }
    dispatch({
      type: "set_has_2018_reco_letter_config",
      payload: response.data,
    });
  };
};

export const download2018RecoLetter = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get("/oas/api/v1/download2018recoletter", {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? JSON.parse(await error.response.data.text()).message
          : error.message;
      toastr.error(errorMessage);
      return;
    }
    FileDownload(response.data, `Reco_Letter.pdf`);
  };
};

export const getGuidelineLinks = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=guidelinelinks`);
      if (response && response.data && response.data.length > 0 && response.data[0].value) {
        let responseData = response.data[0].value ? JSON.parse(response.data[0].value) : '';
        dispatch({
          type: SET_GUIDELINE_LINKS,
          payload: responseData,
        });
      }

      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_SHOWING_GUIDELINE_LINKS,
          errorMessage);
        return;
      }
    }
  };
};


export const getProfileLockUnlockFlg = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=enableUnlockProfile`);
      if (response && response.data && response.data.length > 0 && response.data[0].value) {
        let responseData = response.data[0].value ? JSON.parse(response.data[0].value) : '';
        dispatch({
          type: SET_LOCK_UNLOCK_PROFILE_FLG,
          payload: responseData,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());

      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_LOCKING_UNLOCKING_PROFILE,
          errorMessage);
        return;
      }
    }
  };
};


export const getEditProfileWithLock = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=editProfileWithLock`);
      if (response && response.data && response.data.length > 0 && response.data[0].value) {
        let responseData = response.data[0].value ? JSON.parse(response.data[0].value) : '';

        dispatch({
          type: EDIT_SET_LOCK_UNLOCK_PROFILE,
          payload: responseData,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_LOCKING_UNLOCKING_PROFILE,
          errorMessage);
        return;
      }
    }
  };
};


export const getDepartments = () => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      let response = await API.get(GET_DEPARTMENTS)
      if (response) {
        dispatch({
          type: SET_ADMIN_DEPARTMENTS,
          payload: response.data
        })
      }

      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      console.error(error)
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  }
}

export const getAdminMobileOTP = (userData, setOtpId) => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const OTPDetails = {
        email: "",
        mobile: userData.userName,
        type: "mobile",
        otpFor: "login",
        sendOtpTo: "mobile",
        sendOtpDifferent: false,
        departmentName: "IT",
        depatmentId: "1"
      }
      let response = await API.post(GET_ADMIN_OTP, OTPDetails)
      if (response && response.data) {
        toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_MOBILE)
        setOtpId(response.data[0].id)
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());

      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_SENDING_MOBILE_OTP,
          errorMessage);
        return;
      }
    }
  }
}

export const getAdminEmailOTP = (userData, setOtpId) => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const OTPDetails = {
        email: userData.userName,
        mobile: "",
        type: "email",
        otpFor: "login",
        sendOtpTo: "email",
        sendOtpDifferent: false,
        departmentName: "IT",
        depatmentId: "1"
      }
      let response = await API.post(GET_ADMIN_OTP, OTPDetails)
      if (response && response.data) {
        toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_EMAIL)
        setOtpId(response.data[0].id)
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.ERROR_WHILE_SENDING_EMAIL_OTP, errorMessage);
        return;
      }
    }
  }
}

export const verifyAdminMobileOTP = (userData, otpId) => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const request = {
        username: userData.userName,
        otp: userData.mobileOTP,
        id: otpId,
        type: "mobile",
        otpFor: "login"
      }
      let response = await API.post(VERIFYOTP, request)
      if (response && response.data) {
        toastr.success(commonLabels.COMMON.OTP_VERIFICATION_SUCCESSFUL)
        dispatch({
          type: SET_ADMIN_OTP_VERIFIED_FLAG,
          payload: true
        })
      }
      else {
        toastr.error(
          commonLabels.COMMON.OTP_VERIFICATION_UNSUCCESSFUL
        );
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.COMMON.OTP_VERIFICATION_UNSUCCESSFUL, errorMessage);
        return;
      }
    }
  }
}

export const verifyAdminEmailOTP = (userData, otpId) => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const request = {
        username: userData.userName,
        otp: userData.emailOTP,
        id: otpId,
        type: "email",
        otpFor: "login"
      }
      let response = await API.post(VERIFYOTP, request)
      if (response && response.data) {
        toastr.success(commonLabels.COMMON.OTP_VERIFICATION_SUCCESSFUL)
        dispatch({
          type: SET_ADMIN_OTP_VERIFIED_FLAG,
          payload: true
        })
      }
      else {
        toastr.error(
          commonLabels.COMMON.OTP_VERIFICATION_UNSUCCESSFUL
        );
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.COMMON.OTP_VERIFICATION_UNSUCCESSFUL,
          errorMessage);
        return;
      }
    }
  }
}

export const adminLogin = (userData, navigate) => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const adminDetails = {
        username: userData.userName.trim(),
        password: userData.Password,
        departmentId: userData.departmentId
      }
      let response = await API.post(ADMIN_LOGIN, adminDetails)
      if (response && response.data) {
        const token = response.data.jwtResponse.token;
        sessionStorage.setItem("session", JSON.stringify(response.data));
        // let responseForSecurityQuestion = await API.get(
        //   VERIFY_SECURITY_ANSWER + `?username=${userData.username}`,
        //   { headers: { Authorization: `Bearer ${token}` } }
        // );
        // if (responseForSecurityQuestion != null) {
        //   dispatch(hideLoader());
        // }
        // if (responseForSecurityQuestion.status == 200) {
        //   const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        //   session.securityAnswer = responseForSecurityQuestion.data;
        //   sessionStorage.setItem("session", JSON.stringify(session));
        // }
        // dispatch({
        //   type: SET_SECURITY_ANSWERS_FOR_LOGIN,
        //   payload: response.data.securityAnswerList,
        // });

        dispatch({
          payload: token,
          authData: response.data,
          type: SET_USER_SESSION,
        });

        let message = commonLabels.COMMON.LOGIN_SUCCESS;
        toastr.success(message);
        if (token) {
          navigate("/oasadmin/dashboard");
        }
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());

      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.COMMON.LOGIN_FAILED,
          errorMessage);
        return;
      }
    }
  }
}


export const dashboardCount = () => {
  return async (dispatch) => {
    dispatch(showLoader())
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      const response = await API.get(GET_DASHBOARD_COUNT
        , {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      if (response && response.data) {
        dispatch({
          payload: response.data,
          type: DASHBOARD_COUNT,
        })
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());

      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonLabels.COMMON.LOGIN_FAILED,
          errorMessage);
        return;
      }
    }
  }
}

export const checkModuleEnableDisable = (moduleName, flg) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (flg) {
        dispatch({
          type: SET_API_CALL_FOR_MODULE,
          payload: true,
        });
      }
      let response = await API.get(MODULE_CHECK + `/${moduleName}`);
      if (response.data) {
        dispatch({
          type: SET_MODULE_ENABLE_DISABLE,
          payload: response.data,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage);
      return;
    }
  };
};

export const easebuzzcallback = (method, request = "") => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.post(EASEBUZZ_CALLBACK + `/${method}`, request);
      if (response.data) {
        toastr.success(commonLabels.PAYMENT_SUCCESSFULLY_COMPLETED);
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage);
      return;
    }
  };
};

export const forceFullyLogoutAPI = async () => {
  try {

    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";

    let userId = session.userId;

    let requestBody = {
      userId: userId,
      userName: session.mobileNumber.toString(),
      isAdminUser: false,
    };

    const logoutResponse = await API.patch(FORCEFULLY_LOGOUT, requestBody);
    if (logoutResponse != null) {
      sessionStorage.clear();
      sessionStorage.removeItem("session");
      setTimeout(() => {
        window.location.href = "/candidate/login";
      }, 1000);
      toastr.success(logoutResponse.data.message);
    } else {

      console.error(commonEnLabels.COMMON.LOG_OUT_FAILED);
    }
  } catch (error) {
    let errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    console.error(commonEnLabels.COMMON.LOG_OUT_FAILED, errorMessage);
  }
};

export const loginAction = (loginDetails, setShowCaptcha) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let request = {
        username: loginDetails.userName.trim(),
        password: loginDetails.Password,
        //   otpId: emailOTPResponse.id,
        //   enteredOtp: loginDetails.OTP_email,
        //   otpType: emailOTPResponse.type,
      };
      let response = await API.post(LOGIN, request);
      if (response && response.data) {
        //   dispatch(getSecurityQuestions());
        dispatch({
          type: GET_LOGIN_STATUS,
          payload: response.data.message,
        });
        if (response.data.message === "success") {
          dispatch(generateCaptcha());
          setShowCaptcha(true);
        } else {
          setShowCaptcha(false);
        }
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      if (
        errorMessage &&
        errorMessage.includes(commonLabels.COMMON.ALREADY_LOGIN_NOTE)
      ) {
        toastr.confirm(errorMessage);
      } else {
        toastr.error(commonLabels.COMMON.LOGIN_FAILED, errorMessage);
      }
    }
  };
};

export const onCaptchaProceed = (
  props,
  loginDetail,
  captchaId,
  userDetail,
  navigate
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let request = {
        captchaId: captchaId,
        enteredCaptcha: loginDetail,
        username: userDetail.userName.trim(),
        password: userDetail.Password,
      };
      let response = await API.post(GET_VERIFY_CAPTCHA, request)
      if (response && response.data) {
        const token = response.data.jwtResponse.token;
        sessionStorage.setItem("session", JSON.stringify(response.data));
        // const token = response.data.jwtResponse.token;
        let responseForSecurityQuestion = await API.get(
          VERIFY_SECURITY_ANSWER + `?username=${request.username}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (responseForSecurityQuestion != null) {
          dispatch(hideLoader());
        }
        if (responseForSecurityQuestion.status === 200) {
          const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
          session.securityAnswer = responseForSecurityQuestion.data;
          sessionStorage.setItem("session", JSON.stringify(session));
        }

        dispatch({
          type: SET_SECURITY_ANSWERS_FOR_LOGIN,
          payload: response.data.securityAnswerList,
        });
        dispatch({
          payload: token,
          type: SET_USER_SESSION,
        });
        let message = response.data.message ? response.data.message : "";
        toastr.success(message);

        if (token) {
          let response1 = await API.get(GET_DIGILOCKER_URL);

          if (response1 && response1.data != null) {

            if (response1 && response1.data == false) {

              navigate("/candidate/main");
            }
            window.location.href = response1.data;

          }

          // props.history.push("/candidate/main");
          // dispatch(getDigilockerLink(navigate, "/candidate/main"));
          // navigate("/candidate/main");
        }
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      if (
        errorMessage &&
        errorMessage.includes(commonLabels.COMMON.ALREADY_LOGIN_NOTE)
      ) {
        toastr.confirm(errorMessage);
      } else {
        toastr.error(commonLabels.COMMON.LOGIN_FAILED, errorMessage);
      }
      toastr.error(errorMessage);
    }
  };
};
export const getDigilockerLink = (navigate, link) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {

      let response = await API.get(GET_DIGILOCKER_URL);

      if (response && response.data != null) {

        if (response && response.data == false) {
          navigate(link);
        }
        window.location.href = response.data;

      }

      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;

      toastr.error(errorMessage)
    }
  };
};

export const getDigilockerAccessToken = (authCode, userEmail, userHscYear, userHscBoard, userHscRollNo) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = "";
      if (userEmail && userHscYear && userHscBoard && userHscRollNo && authCode) {
        response = await API.post(GET_DIGILOCKER_ACCESSTOKEN, { 'email': userEmail, 'year': userHscYear, 'orgid': userHscBoard, 'rollno': userHscRollNo, 'code': authCode });
        sessionStorage.removeItem("userEmail");
        sessionStorage.removeItem("userHscYear");
        sessionStorage.removeItem("userHscBoard");
        sessionStorage.removeItem("userHscRollNo");

        sessionStorage.clear();
        sessionStorage.removeItem("session");
        if (response && response.data) {
          dispatch({
            payload: response.data,
            type: SET_DIGILOCKER_ACCESSTOKEN_DATA,
          });

        }
      }

      if (response != null) {
        dispatch(hideLoader());

      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};

export const getBoardsList = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "profile_creation",
          type: "board",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }

      dispatch({
        payload: response && response.data ? response.data.lookupOptionDtoList : [],
        type: SET_BOARDS_LIST,
      });


      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};

export const getDigilockerAccessToken2 = (authCode, navigate) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let profileId = session ? session.profileId : "";
      let response = "";
      if (profileId && authCode) {
        response = await API.post(GET_DIGILOCKER_ACCESSTOKEN_LOGIN, { 'profileid': profileId, 'code': authCode });
        if (response && response.data && !(response.data.error)) {
          dispatch({
            payload: response.data,
            type: SET_DIGILOCKER_ACCESSTOKEN_DATA,
          });

          dispatch(getPersonalInfoDigilockerStatus());
          sessionStorage.setItem("digilocker_accesstoken", response.data);

        }
      }


      if (response != null) {
        dispatch(hideLoader());
        navigate("/candidate/main");
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;

      toastr.error(errorMessage)
    }
  };
};

export const getHelplineDetails = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=helpline`);
      if (response && response.data && response.data.length > 0 && response.data[0].value) {
        let responseData = response.data[0].value ? JSON.parse(response.data[0].value) : '';
        dispatch({
          type: SET_HELPLINE_DETAILS,
          payload: responseData,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};



export const grievanceSubmit = (data, mobile) => {
  return async (dispatch) => {
    dispatch(showLoader());

    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const userTypeCode = session && session ? session.userTypeCode : ""
    try {
      const formData = new FormData();
      formData.append('email', data.email);
      formData.append('mobile', data.mobile);
      formData.append('type', data.type);
      formData.append('advtNumber', data.advtType);
      formData.append('subType', data.grievSubType);
      formData.append('description', data.description);
      formData.append('userTypeCode', userTypeCode);
      // Only append photo if it is selected
      if (data.photo) {
        formData.append("documentFile", data.photo);
      }

      let header = {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        type: "formData",
      };

      let response = await axios.post(GRIEVANCE_SAVE, formData, {
        headers: header,
      });

      if (response.status === 200) {
        toastr.success(response.data.message);
        // toastr.success(commonLabels.GRIEVANCE_SAVED_MESSAGE)
      }

      // userTypeCode && dispatch(getGrievanceList(mobile))

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};

export const getGrievanceList = (mobile) => {
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      const token = session.jwtResponse && session.jwtResponse.token;
      let response = await axios.get(GET_GRIEVANCE_LIST + `/${mobile}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response && response.data) {
        dispatch(hideLoader());
        dispatch({
          type: GRIEVANCE_LIST,
          payload: response.data,
        });
      }

    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};


export const getGrievanceById = (id) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {

      let response = await API.get(GET_GRIEVANCE_DETAILS + `/${id}`);
      if (response && response.data) {
        dispatch(hideLoader());
        dispatch({
          type: GRIEVANCE_DETAILS,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};


export const generateGrievanceOTP = (otpDetails) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let request;
      switch (otpDetails.type) {

        case "mobile":
          if (otpDetails.mobile === "") {
            dispatch(hideLoader());
            toastr.info(commonLabels.ENTER_VALID_MOBILE_NUMBER);
            return;
          }
          request = {
            email: "",
            mobile: otpDetails.mobile,
            username: "",
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
          };
          break;

        default:
          dispatch(hideLoader());
          toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
          return;
      }

      let response = await API.post(OTPS, request);
      let emailOTPResponse;
      let mobileOTPResponse;
      let userNameOTPResponse;
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        switch (response.data.type) {

          case "MOBILE":
            mobileOTPResponse = {
              id: response.data.id,
              type: response.data.type,
            };

            dispatch({
              payload: mobileOTPResponse,
              type: SET_GET_MOBILE_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_DATA_MOBILE,
            });

            toastr.success(commonLabels.OTP_SENT_ON_REGISTERED_MOBILE);
            break;

          default:
            toastr.info(commonLabels.ERROR_WHILE_GENERATING_OTP);
            return;
        }
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      if (
        errorMessage ===
        commonEnLabels.VALIDATE_MESSAGE.NOT_A_REGISTERED_MOBILE_NO
      ) {
        dispatch({
          payload: true,
          type: SET_GET_MOBILE_OTP_FLAG,
        });
      } else if (
        errorMessage ===
        commonEnLabels.VALIDATE_MESSAGE.NOT_A_REGISTERED_EMAIL_ID
      ) {
        dispatch({
          payload: true,
          type: SET_GET_EMAIL_OTP_FLAG,
        });
      }
      toastr.error(commonLabels.GET_OTP_ERROR, errorMessage);
    }
  };
};

export const setGrievanceTableList = (data) => {
  return function (dispatch) {
    try {
      dispatch({
        payload: data,
        type: SET_GRIEVANCE_TABLE_LIST,
      });

    } catch (error) {
      console.error("Error while setting Grievance table list.", error)
    }
  };
};
export const updateGrievanceData = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let sessionData = JSON.parse(sessionStorage.getItem('session'));
      const userMobile = sessionData.mobileNumber;
      const response = await API.patch(UPDATE_GRIEVANCE_DATA, data);

      if (response != null) {
        dispatch(hideLoader());
        // dispatch(getGrievanceList(userMobile));
      }

    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;

      toastr.error(errorMessage);
    }
  };
};

export const getDigilockerFlagAPI = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=enableDigiLocker`);
      if (response && response.data && response.data[0].value) {
        let responseData = response.data[0].value ? JSON.parse(response.data[0].value) : '';
        dispatch({
          type: SET_CONFIGURATION_DIGILOCKER_FLAG,
          payload: responseData,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};



export const getAdvertisementTypeDropdownValues = () => {
  return async (dispatch) => {
    try {

      dispatch(showLoader());
      let response = await API.get(GET_ADVERTISEMENT_DROPDOWN, {
      });

      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        type: GET_ADVERTISEMENT_TYPE_DROPDOWN_LIST,
        payload: response && response.data ? response.data : [],
      });
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error("Error while fetching Advertisement", errorMessage);
        return;
      }
    }
  };
};




// Grievance Type 

export const getGrievanceTypeDropdown = (id) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "grievance_type"
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data.lookupOptionDtoList ? response.data.lookupOptionDtoList : [],
        type: GET_TYPE_GRIEVANCE_DROPDOWN_LIST,
      });
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
      throw new Error(error.message);
    }
  };
};

// Get Grievance Type Dropdown
export const getGrievanceTypeDropdownValues = () => {
  return async (dispatch) => {
    try {

      dispatch(showLoader());
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "grievance_type",
          // type: "grievance",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data.lookupOptionDtoList ? response.data.lookupOptionDtoList : [],
        type: GET_GRIEVANCE_TYPE_DROPDOWN_LIST,
      });
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};


// Sub Grievance Type 
export const getSubGrievanceTypeDropdown = (id) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "grievance",
          type: id,
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }

      dispatch({
        payload: response && response.data.lookupOptionDtoList ? response.data.lookupOptionDtoList : [],
        type: GET_SUB_TYPE_GRIEVANCE_DROPDOWN_LIST,
      });
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
      throw new Error(error.message);
    }
  };
};


export const verifyQualificationDigilocker = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let profileId = session ? session.profileId : "";
      let response = "";
      if (profileId && sessionStorage.getItem("digilocker_accesstoken")) {
        response = await API.post(VERIFY_QUALIFICATION_DIGILOCKER, { 'profileid': profileId, "digiLockerToken": sessionStorage.getItem("digilocker_accesstoken") });
        if (response && response.data && !(response.data.error)) {
          dispatch({
            payload: response.data,
            type: SET_DIGILOCKER_ACCESSTOKEN_DATA,
          });
          sessionStorage.setItem("digilocker_accesstoken", response.data);
        }
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(errorMessage)
    }
  };
};


// To show Grievace PFd in chrome if not opening directly 


export const handlePdfView = (pdf) => {
  if (pdf) {
    try {
      const base64Data = pdf.replace(/^data:application\/pdf;base64,/, '');
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const pdfBlob = new Blob([byteNumbers], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      /*
    Added download functionlity here if need to download 
      const downloadLink = document.createElement('a');
      downloadLink.href = pdfUrl;
      downloadLink.download = 'document.pdf'; // Provide a default file name
      downloadLink.click();
  */
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 10000);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  } else {
    console.warn("No PDF data found.");
  }
};


// To get application version

export const getAppVersion = (id) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await axios.get(APPLICATION_VERSION_API);
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        type: GET_WEB_APP_VERSION,
        payload: response.data
      })
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
      throw new Error(error.message);
    }
  };
};


export const getYearList = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_YEAR_LIST}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_YEAR,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};

export const showApplicationStagesView = (flag) => {
  return async (dispatch) => {
    dispatch({
      payload: flag,
      type: SET_APPLICATION_STAGES_VIEW
    })
  }
};

export const getAdvertisement = (skipPage, limitPage, year) => {
  return async function (dispatch) {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;
    let skip = Number(skipPage);
    let pageLimit = Number(limitPage);
    let response;
    try {
      response = await API.get(GETADVERTISEMENT + `/${skip}` + `/${pageLimit}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { "year": year }
      });
      dispatch({
        type: SET_GET_ACTIVE_ADVERTISEMENT,
        payload: response.data,
      });
    } catch (error) {
      let errorMessage = (error.response && error.response.data) ?
        error.response.data.message : error.message
      toastr.error(errorMessage);
      return;
    }

  };
};

export const getPastAdvertisement = (skipPage, limitPage, year) => {
  return async function (dispatch) {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;
    let skip = Number(skipPage);
    let pageLimit = Number(limitPage);
    let response;
    try {
      response = await API.get(GETPASTADVERTISEMENT + `/${skip}` + `/${pageLimit}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { "year": year }
      });
      dispatch({
        type: SET_GET_PAST_ADVERTISEMENT,
        payload: response.data,
      });
    } catch (error) {
      let errorMessage = (error.response && error.response.data) ?
        error.response.data.message : error.message
      toastr.error(errorMessage);
      return;
    }

  };
};

export const resetAdvertisementDetails = () => {
  return async (dispatch) => {
    dispatch({
      type: SET_ADVT_DETAILS,
      payload: [],
    });
  }
}

export const getActiveSlideShowAdvt = () => {
  return async function (dispatch) {
    try {
      const response = await API.get(GET_SLIDE_SHOW_ACTIVE_ADVT_API);
      dispatch({
        type: GET_SLIDE_SHOW_ACTIVE_ADVT,
        payload: response.data.advertisements
      })
    } catch (error) {
      if (error && error.response) {
        console.error(error)
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(commonEnLabels.FACING_ISSUE_GETTING_ACTIVE_ADVT, errorMessage);
        return;
      }
    }
  }
}


export const formatDateDDMMYY = (d) => {
  const date = new Date(d);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export const getOTRdetails = () => {
  return async function (dispatch) {
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      const token = session.jwtResponse && session.jwtResponse.token;
      let userId = session.userId;
      const response = await API.get(GET_OTR_DETAILS + '?userId=' + userId);
      dispatch({
        type: SET_OTR_DETAILS,
        payload: response.data
      })
    } catch (error) {
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
      console.error(error)
    }
  }
}


export function validateFieldsForSpaces(fields) {
  for (const [fieldName, fieldValue] of Object.entries(fields)) {
    const originalValue = fieldValue ?? ''; // handle null/undefined gracefully

    // Check for leading/trailing spaces
    if (/^\s|\s$/.test(originalValue)) {
      toastr.error(`${fieldName} should not have leading or trailing spaces.`);
      return false;
    }

    // Check for double or more spaces between words
    if (/\s{2,}/.test(originalValue)) {
      toastr.error(`Please remove extra spaces between words in ${fieldName}.`);
      return false;
    }
  }
  return true; // all fields passed validation
}